import React from "react"

type Props = {
  pageTitle: string
  className: string
}
const PrivacyHero: React.FC<Props> = ({
    pageTitle,
    className,
  }) => {
    return (
    <section
    className={`hero technology-herosection ${className}`}>
      <div className="container lg:container md:mx-auto top-hero">
      <div className="row grid lg:grid-cols-12 policy-height flex justify-center items-center">
      <div className="text-center lg:col-span-8 lg:col-start-3">       
      <h1 className="mb-0 dark:text-textcolor">{pageTitle}</h1>
      </div>
        </div>
      </div>
    </section>
  )
}

export default PrivacyHero
